var map = {
	"./af/Category.json": 88877,
	"./af/CostCentre.json": 52487,
	"./af/CustomerLocation.json": 50671,
	"./af/Delivery.json": 52834,
	"./af/PickingList.json": 75043,
	"./af/PickingListItem.json": 90044,
	"./af/PreferredDeliveryAddress.json": 35822,
	"./af/Shop.json": 94068,
	"./af/StockItem.json": 19862,
	"./af/Supplier.json": 70337,
	"./af/common.json": 63165,
	"./en/Category.json": 9936,
	"./en/CostCentre.json": 52159,
	"./en/CustomerLocation.json": 26383,
	"./en/Delivery.json": 84044,
	"./en/Orders.json": 71612,
	"./en/PickingList.json": 51793,
	"./en/PickingListItem.json": 22502,
	"./en/PreferredDeliveryAddress.json": 27112,
	"./en/RestaurantAdmins.json": 50303,
	"./en/Shop.json": 35051,
	"./en/StockItem.json": 51167,
	"./en/Supplier.json": 13357,
	"./en/common.json": 10040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23580;